export type VerifySufficientFundsParams = {
  companyId: number | string;
  amount: number;
  paymentMethodId?: string;
};

export type VerifySufficientFundsPayload = {
  methodId: string | undefined;
  hasSufficientFunds: boolean;
};

export type FetchPaymentMethodsParams = {
  companyId: string | number;
  initialLoad?: boolean;
};

export type FetchPaymentMethodsPayload = {
  autoConnectStatus: AutoConnectStatus;
  paymentMethods: PaymentMethod[];
};

export type PaymentMethod = {
  name: string;
  id: string;
  type: string;
  cardType: string;
  isDefault: boolean;
  createdDate: string;
};

export enum AutoConnectStatus {
  NoInitialSelection,
  InitialSelectionAutoConnect,
  InitialSelectionPaymentMethodOnly,
  InitialSelectionSetupLater,
  Enabled,
  Disabled
}

export type ConnectionsBillingPreviewPayload = {
  taxes: number;
  total: number;
  connections: IPendingBillingConnection[];
};

export interface IPendingBillingConnection {
  currency: string;
  organizationId: string;
  companyName: string;
  companyId: number;
  isBillingZone: boolean;
  isAdminOverride: boolean;
  isPotentialCap: boolean;
  isCap: boolean;
  isPendingConnection: boolean;
  isReconnect: boolean;
  isPotentialRollUp: boolean;
  isRollUp: boolean;
  opportunityId: any;
  price: number;
}

export type ConnectionsBillingPreviewParams = {
  companyName: string;
  organizationId: string;
  companyId: number;
  hiringClients: HiringClientType[];
};

export type HiringClientType = {
  organizationId: string;
  companyName: string;
  companyId: number;
  isPendingConnection: boolean;
};

export type SetDefaultMethodParams = {
  companyId: string;
  paymentMethodId: string;
};
